import { Component, h, render } from '@monygroupcorp/microact';
import { FloatingWalletButton } from '../FloatingWalletButton/FloatingWalletButton.js';
import WalletModal from '../Wallet/WalletModal.js';

class WalletButtonModal extends WalletModal {
    handleWalletClick(walletKey) {
        if (this.props.onWalletSelected) {
            this.props.onWalletSelected(walletKey);
        }
        this.hide();
    }
}

export class WalletButton extends FloatingWalletButton {
    constructor(props) {
        super(props);
        this.modalRoot = null;
    }

    showWalletModal() {
        const wallets = this.walletService
            ? this.walletService.getAvailableWallets()
            : {};

        if (!this.walletModal) {
            if (!this.modalRoot) {
                this.modalRoot = document.createElement('div');
                document.body.appendChild(this.modalRoot);
            }

            render(h(WalletButtonModal, {
                wallets,
                onWalletSelected: async (walletKey) => {
                    await this.handleWalletSelection(walletKey);
                },
                ref: instance => this.walletModal = instance
            }), this.modalRoot);
        } else {
            // Update wallets prop on existing modal for late-arriving EIP-6963 providers
            this.walletModal.props.wallets = wallets;
        }

        this.walletModal?.show();
    }

    willUnmount() {
        if (this.modalRoot?.parentNode) {
            this.modalRoot.parentNode.removeChild(this.modalRoot);
            this.modalRoot = null;
        }
        super.willUnmount();
    }

    render() {
        if (this.state.loading) {
            return h('div', { className: 'floating-wallet-button loading' },
                h('div', { className: 'wallet-spinner' })
            );
        }

        const { walletConnected, address, balance, menuOpen } = this.state;

        if (!walletConnected) {
            return h('div', { className: 'floating-wallet-button disconnected', ref: el => this.element = el },
                h('button', {
                    className: 'wallet-btn',
                    onClick: this.bind(this.handleWalletToggle)
                },
                    h('span', { className: 'wallet-mark' }),
                    h('span', { className: 'wallet-text' }, 'Connect Wallet')
                )
            );
        }

        const truncatedAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
        const classNames = ['floating-wallet-button', 'connected'];
        if (menuOpen) {
            classNames.push('menu-open');
        }

        return h('div', { className: classNames.join(' '), ref: el => this.element = el },
            h('button', {
                className: 'wallet-btn',
                title: `${this.escapeHtml(address)}\nBalance: ${balance} ETH`,
                onClick: this.bind(this.handleWalletToggle)
            },
                h('span', { className: 'wallet-mark wallet-mark--connected' }),
                h('span', { className: 'wallet-address' }, this.escapeHtml(truncatedAddress)),
                h('span', {
                    className: 'wallet-disconnect',
                    title: 'Disconnect',
                    onClick: this.bind(this.handleInlineDisconnect)
                }, '\u23CF\uFE0E')
            ),
            this.renderWalletPanel(address, balance, menuOpen)
        );
    }

    renderWalletPanel(address, balance, menuOpen) {
        const truncatedAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;

        return h('div', {
            className: 'wallet-info-panel',
            'aria-hidden': menuOpen ? 'false' : 'true'
        },
            h('div', { className: 'wallet-info-row' },
                h('span', { className: 'wallet-info-label' }, 'Address'),
                h('span', { className: 'wallet-info-value' }, this.escapeHtml(truncatedAddress))
            ),
            h('div', { className: 'wallet-info-row' },
                h('span', { className: 'wallet-info-label' }, 'ETH Balance'),
                h('span', { className: 'wallet-info-value' }, `${balance} ETH`)
            )
        );
    }

    didUpdate() {
        if (this.state.menuOpen) {
            this.attachOutsideClickListener();
        } else {
            this.detachOutsideClickListener();
        }
    }

    attachOutsideClickListener() {
        if (this.outsideClickHandler || this.outsideClickTimeout) return;
        this.outsideClickHandler = (event) => {
            if (!this.element) return;
            const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
            const clickedInside =
                (path.length && path.includes(this.element)) ||
                (event.target && this.element.contains(event.target));
            if (!clickedInside) {
                this.setState({ menuOpen: false });
            }
        };
        this.outsideClickTimeout = window.setTimeout(() => {
            document.addEventListener('click', this.outsideClickHandler);
            this.outsideClickTimeout = null;
        }, 0);
    }

    detachOutsideClickListener() {
        if (this.outsideClickTimeout) {
            window.clearTimeout(this.outsideClickTimeout);
            this.outsideClickTimeout = null;
        }
        if (this.outsideClickHandler) {
            document.removeEventListener('click', this.outsideClickHandler);
            this.outsideClickHandler = null;
        }
    }

    handleWalletToggle(e) {
        this.handleButtonClick(e);
    }

    handleInlineDisconnect(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.handleDisconnect(e);
    }
}

export default WalletButton;
